import "./App.css";

import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Dashboard from "./pages/dashboard";
import AddCartDetails from "pages/addCartDetails";
import ProductDetails from "pages/productDetails";
import OrderDetails from "pages/orderDetails";
import HotOffer from "pages/hotOffer";
import ConfirmOrder from "pages/confirmOrder";
import CategoryWiseData from "pages/categoryWiseData";
import NewProductsFullPage from "pages/newProductsFullPage";
import TrendingProductsFullPage from "pages/TrendingProductsFullPage";
import FreeDeliveryFullPage from "pages/FreeDeliveryFullPage";
import Navbar from "assets/Navbar";
import MobileBottomNav from "assets/MobileBottomNav";
import AboutUs from "pages/aboutUs";
import ContactUs from "pages/contactUs";
import TermsCondition from "pages/termsCondition";
import FooterSection from "assets/Footer";
import ScreenScrollToTop from "components/ScreenScrollToTop";
import ContactUsFloatingButton from "components/ContactUsFloatingButton";
import { SettingsProvider } from "./context/SettingsContext";

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });

    console.log("page_view fired", location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <ContactUsFloatingButton />
        <PageTracker />
        <Navbar />
        <div className="pb-0 md:pb-0 select-none">
          <Routes>
            <Route path="/" exact element={<Dashboard />}></Route>
            <Route path="/home" exact element={<Dashboard />}></Route>
            <Route
              path="/category/:catalogueId"
              exact
              element={<CategoryWiseData />}
            />
            <Route
              path="/details/:category/:id"
              exact
              element={<ProductDetails />}
            ></Route>
            <Route path="/hotOffer" exact element={<HotOffer />}></Route>
            <Route
              path="/allNewProduct"
              exact
              element={<NewProductsFullPage />}
            ></Route>
            <Route
              path="/trendingProducts"
              exact
              element={<TrendingProductsFullPage />}
            ></Route>
            <Route
              path="/freeDeliveryProducts"
              exact
              element={<FreeDeliveryFullPage />}
            ></Route>
            <Route path="/cart" exact element={<AddCartDetails />}></Route>
            <Route
              path="/orderDetails"
              exact
              element={<OrderDetails />}
            ></Route>
            <Route
              path="/confirmOrder"
              exact
              element={<ConfirmOrder />}
            ></Route>
            <Route path="/aboutUs" exact element={<AboutUs />}></Route>
            <Route path="/contactUs" exact element={<ContactUs />}></Route>
            <Route
              path="/terms&condition"
              exact
              element={<TermsCondition />}
            ></Route>
          </Routes>
        </div>
        <ScreenScrollToTop />

        {/* <FooterSection /> */}
        <MobileBottomNav />
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
